import { Routes } from '@angular/router';
import { CommandAdminComponent } from './components/command-admin/command-admin.component';

export const COMMAND_ROUTES: Routes = [{
	path: 'Command', component: CommandAdminComponent
}];
